import React, { lazy, Suspense } from 'react';
import { motion } from 'framer-motion';
import GlassButton from './GlassButton';
import Typewriter from './Typewriter';

const ParticleSphere = lazy(() => import('./ParticleSphere'));

const Hero = () => {
  return (
    <section
      id='home'
      className='lg:h-[87vh] flex items-center bg-primary lg:bg-cover lg:bg-center lg:bg-no-repeat py-32 lg:py-0 overflow-hidden'
    >
      <div className='container mx-auto h-full'>
        <div className='flex items-center h-full pt-8'>

          {/* ── Left: text ── */}
          <div className='flex-1 flex flex-col items-center lg:items-start'>
            <motion.p
              className='hidden lg:block text-lg text-accent mb-[28px]'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2 }}
            >
              {'//'}
            </motion.p>

            <motion.h1
              className='hidden lg:block text-4xl leading-[38px] md:text-5xl md:leading-tight lg:text-5xl lg:leading-[1.22] font-bold md:tracking-[-1px] min-h-[2.4em]'
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, ease: 'easeOut' }}
            >
              <Typewriter
                phrases={["Hello there, I'm Seth."]}
                typeSpeed={65}
                deleteSpeed={32}
                pauseMs={7000}
                deletePauseMs={1200}
                wrapper="span"
              />
            </motion.h1>

            <motion.p
              className='hidden lg:block pt-4 pb-8 md:pt-6 md:pb-12 max-w-[480px] text-xl text-center lg:text-left'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              Software engineer, researcher, reader.
            </motion.p>

            {/* Mobile particle sphere */}
            <div className='flex lg:hidden w-full justify-center items-center mt-2' style={{ position: 'relative', minHeight: '380px' }}>
              <div style={{ width: '380px', height: '380px', position: 'relative', top: '-40px' }}>
                <Suspense fallback={<div style={{ width: '380px', height: '380px' }} />}>
                  <ParticleSphere scale={1.6} style={{ width: '380px', height: '380px', position: 'relative', top: 'auto', right: 'auto', transform: 'none' }} />
                </Suspense>
              </div>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, ease: 'easeOut' }}
              className='relative z-[120]'
            >
              <GlassButton
                onClick={() => window.open('https://www.instagram.com/seth.nuzum/', '_blank', 'noopener,noreferrer')}
                width={220}
                height={54}
                glassProps={{
                  backgroundOpacity: 0.05,
                  displace: 16,
                  distortionScale: -220,
                  redOffset: 0,
                  greenOffset: 14,
                  blueOffset: 28,
                  saturation: 1.4,
                  brightness: 80,
                  opacity: 0.82,
                }}
              >
                Connect with me
              </GlassButton>
            </motion.div>
          </div>

          {/* ── Right: particle sphere (desktop) ── */}
          <div className='hidden lg:flex flex-1 justify-center items-center' style={{ position: 'relative', minHeight: '400px' }}>
            <div style={{ width: '400px', height: '400px', position: 'relative' }}>
              <Suspense fallback={<div style={{ width: '400px', height: '400px' }} />}>
                <ParticleSphere />
              </Suspense>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
